/**
 * Stadtbezirke — Konfigurations-Daten für "Mein Veedel".
 *
 * Stadt-Bezug ist bewusst NUR hier (Inhalt/Konfiguration, nie Struktur):
 * für ein Portal einer anderen Stadt wird nur diese Liste getauscht.
 * Die Slugs sind stabil — sie stecken in URLs (/veedel/:bezirk), im
 * UserProfile (bezirk) und in den Fach-Entitäten (Organization.bezirk,
 * Location.bezirk).
 */

export interface Bezirk {
  /** URL-Slug, stabil (siehe Kommentar oben). */
  slug: string;
  name: string;
  /** Nummer des Stadtbezirks (kommunale Zählung). */
  nr: number;
}

/** Die 9 Kölner Stadtbezirke. */
export const BEZIRKE: Bezirk[] = [
  { slug: "innenstadt", name: "Innenstadt", nr: 1 },
  { slug: "rodenkirchen", name: "Rodenkirchen", nr: 2 },
  { slug: "lindenthal", name: "Lindenthal", nr: 3 },
  { slug: "ehrenfeld", name: "Ehrenfeld", nr: 4 },
  { slug: "nippes", name: "Nippes", nr: 5 },
  { slug: "chorweiler", name: "Chorweiler", nr: 6 },
  { slug: "porz", name: "Porz", nr: 7 },
  { slug: "kalk", name: "Kalk", nr: 8 },
  { slug: "muelheim", name: "Mülheim", nr: 9 },
];

export function bezirkName(slug: string | undefined): string | undefined {
  return BEZIRKE.find((b) => b.slug === slug)?.name;
}

/**
 * Bezirkswahl für Nicht-Eingeloggte: localStorage-Fallback (Abschnitt 3).
 * Eingeloggte speichern den Bezirk im UserProfile (Backend).
 */
export const BEZIRK_SELECTION_KEY = "app.bezirk.selection";
